import ProfileMailing from "./ProfileMailing";
export default ProfileMailing;